import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c04f49de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "api-keys-wrapper" }
const _hoisted_2 = { class: "generate-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Generovat API key", -1))
const _hoisted_4 = { class: "tokens" }

import { NButton, NInput, NInputGroup, useDialog } from 'naive-ui';
import { API } from '@/api';
import { ref, onBeforeMount, h, computed } from 'vue';
import ApiKeyItem from '@/components/ApiKey/ApiKeyItem.vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { getters } = useStore();
const rights = computed(() => getters['auth/rights']);

const newTokenName = ref(null);
const pending = ref(false);
const apiKeys = ref<ApiKey[]>([]);
const dialog = useDialog();

const fetchApiKeys = async () => {
	if (!rights.value.admin) return;

	pending.value = true;

	const response = await API.apiSettings.getApiKeys().catch(() => {});

	pending.value = false;

	if (!response) return;
	if (!Array.isArray(response.payload)) return;

	apiKeys.value = response.payload;
};

const generateApiKey = async () => {
	if (!rights.value.admin) return;

	if (!newTokenName.value) return;

	pending.value = true;

	await API.apiSettings.createApiKey(newTokenName.value).catch(() => {});

	newTokenName.value = null;

	await fetchApiKeys();
};

const removeApiKey = async (id: string) => {
	if (!rights.value.admin) return;

	pending.value = true;

	await API.apiSettings.removeApiKey(id).catch(() => {});

	await fetchApiKeys();
};

const removeApiKeyPrompt = async (apiKey: ApiKey) => {
	if (!apiKey) return;

	dialog.error({
		title: 'Odstranění API tokenu',
		content: () =>
			h('div', [
				h('p', { style: { textAlign: 'center' } }, `Skutečně chcete odstranit token?`),
				h(
					'div',
					{
						style: {
							textAlign: 'center',
							paddingTop: '15px',
							paddingBottom: '15px',
						},
					},
					[
						h('p', { style: { fontSize: '18px', fontWeight: 'bold' } }, `${apiKey.name}`),
						h('p', { style: { fontSize: '12px', color: '#aaa' } }, apiKey.token),
					]
				),
			]),
		positiveText: 'Ano, odstranit',
		negativeText: 'Ne, ponechat',
		onPositiveClick: async () => {
			dialog.destroyAll();
			await removeApiKey(apiKey.id);
		},
		onNegativeClick: () => {
			dialog.destroyAll();
		},
	});
};
onBeforeMount(async () => {
	await fetchApiKeys();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NInputGroup), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NInput), {
            value: newTokenName.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((newTokenName).value = $event)),
            size: "medium",
            type: "text",
            placeholder: "Název API klíče"
          }, null, 8, ["value"]),
          _createVNode(_unref(NButton), {
            size: "medium",
            type: "info",
            loading: pending.value,
            disabled: !newTokenName.value,
            onClick: generateApiKey
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apiKeys.value, (apiKey) => {
        return (_openBlock(), _createBlock(ApiKeyItem, {
          key: apiKey.id,
          "api-key": apiKey,
          pending: pending.value,
          "remove-api-key": removeApiKeyPrompt
        }, null, 8, ["api-key", "pending"]))
      }), 128))
    ])
  ]))
}
}

})